import { EntityKind } from 'mdello-client-ts/dist/src/interfaces/admin/entity.interface';
import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { getClient } from 'src/util/mdello-instance';
import { CitizenRequests } from '../interfaces/requestsResponse.interface';

const fetchCitizenRequests = async (): Promise<CitizenRequests | undefined> => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  const data = await getClient()?.listEntities({
    kind: EntityKind.REQUEST_ACTION,
    projectId: currentProject._id
  });

  if (!data) return;

  return { data: data.data, paging: data.paging };
};

export const useGetCitizenRequests = () => {
  const { notify } = useNotification();

  return useQuery([QueryKey.REQUESTS], () => fetchCitizenRequests(), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    }
  });
};
